<template>
  <div class="header-container">
    <!-- 导航 -->
    <div class="header_nav  w" :class="!isLogin?'unLogin':''">
      <div class="nav_logo" @click="$router.push('/')">
        <img :src="config.logo" :alt="config.site_title" style="width:120px;" class="pointer" />
      </div>
      <div class="nav_right">
        <div class="nav_group">
          <div class="nav-group-left">
            <router-link
                         class="nav_btn"
                         active-class="nav-active"
                         to="/resource/geo?tabbar=3">
              GEO媒体
            </router-link>
            <router-link class="nav_btn"
                         active-class="nav-active"
                         to="/resource/news?tabbar=2">媒体价格
            </router-link>
            <router-link class="nav_btn"
                         active-class="nav-active"
                         to="/resource/zimeiti??tabbar=1">自媒体价格
            </router-link>
            <router-link class="nav_btn"
                         active-class="nav-active"
                         to="/own/publish">文章发布
            </router-link>
            <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         active-class="nav-active"
                         to="/#home">后台首页
            </router-link>
          </div>
        </div>
      </div>
      <div class="head_top_right">
          <span>用户名：
            <router-link to="/">{{ profile.name }}</router-link>
          </span>
        <span>用户ID：
            <router-link to="/">{{ profile.id }}</router-link>
          </span>
        <span v-if="profile.recharge===1">余额：
            <router-link to="/recharge_center" class="pointer active">￥{{ profile.balance }}</router-link>
          </span>
        <span>
            <a @click="onLogout" class="pointer">退出</a>
          </span>
      </div>
    </div>

  </div>

</template>

<script>
import * as Cookies from 'js-cookie'

export default {
  data() {
    return {
      person: {},
      index: 0,
      show: true
    }
  },
  computed: {
    profile() {
      return this.$store.state.profile
    },
    isLogin() {
      return this.$store.state.auth.isLogin
    },
    taxonomies() {
      return this.$store.state.taxonomy
    },
    urlCallback() {
      return escape(document.URL)
    }
  },
  created() {
    if (this.$route.path.split('/')[1] == 'resource') {
      this.show = true
    } else if (this.$route.path.split('/')[1] == 'cart') {
      this.show = true
    } else {
      this.show = false
    }
  },
  methods: {
    onLogout() {
      let loadingInstance = this.$loading({
        text: '注销中...'
      })

      this.$http
          .post('/auth/logout', {device: 'pc'})
          .then(response => {
            if (response.success) {
              //Cookies.remove("bearer");
              window.location.href = '/login'
            }
          })
          .catch()
          .then(() => {
            this.$nextTick(() => {
              loadingInstance.close()
            })
          })
    }
  }
}

</script>

<style scoped lang="scss">
@import './../../../config.scss';

/* 头部 */

.header-container {
  background: #fff;
}

.head {
  background-color: $--head-background;
}

.head.unLogin {
  background-color: $--color-primary;
  position: fixed;
  width: 100%;
  z-index: 100;

  .head_top {
    color: #fff;
    text-align: center;
    justify-content: center;

    .btn {
      border: 1px solid #fff;
      padding: 3px 10px;
      color: #fff;
      border-radius: 2px;

      &:first-child {
        margin-right: 12px;
      }
    }
  }
}

.head_top {
  font-size: 12px !important;
  height: 38px;
  color: $--head-color;
  display: flex;
  justify-content: space-between;
  min-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
}

.head_top_left {
  padding-left: 20px;
}

.head_top_right {
  font-size: 16px;
  color: #666;
}

.head_top_right > span {
  margin-right: 5px;
}

.head_top_right a {
  color: $--head-color;
}

.head_top_right > span:last-child {
  margin-right: 0;
}

.head_top ul {
  /* float: right; */
  margin-right: 48px;
}

.head_top ul li {
  float: left;
  /* margin-left: 10px; */
  font-size: 14px;
  line-height: 35px;
}

.head_top .tel {
  float: right;
  height: 35px;
  line-height: 40px;
}

/* 导航 */


.header_nav {
  width: 1280px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header_nav.unLogin {
  padding-top: 38px;
}

.header_nav .nav_logo {
  width: 180px;
  display: flex;
  align-items: center;
}


.header_nav .nav_right {
  flex: 1;
}

.nav_group {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.nav-group-left {
  flex: 1;
  display: flex;
}


.nav-group-right {
  display: flex;
  justify-content: flex-end;
}

.nav_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333333;
  font-size: 16px;
  height: 36px;
  padding: 0 8px;

  > img {
    margin-right: 8px;
  }

}

/*
*/

.per_center_right ul {
  width: 496px;
  /* margin-right: 36px; */
}

.nav_btn.nav-active {
  background: $--color-primary;
  color: #fff;
  border-radius: 2px;
}

.per_center_right li {
  font-size: 14px;
  color: #434343;
  float: left;
  /* width: 20%; */
  padding: 15px;
  padding-bottom: 0;

  text-align: center;
  line-height: 57px;
  padding-top: 21px;
}

.per_center_right li > a {
  color: #333333;
}

.make_recharge {
  color: $--color-primary;
  border-radius: 2px;
  font-weight: 700;
  width: 100px;
  height: 31px;
  border: 1px solid $--color-primary;

  &:hover {
    background-color: $--color-primary;
    color: #fff
  }

  i {
    margin-right: 4px
  }
}

.header-nav {
  display: flex;
  justify-content: space-between;
}

.header-nav > div {
  margin-left: 278px;
}

.header-nav > div > li {
  margin-right: 20px;
}

.steps {
  display: flex;
  height: 90px;
  justify-content: center;
  align-items: center;
}

.step-item {
  width: 200px;
}

.step-item:nth-child(4) {
  width: 17%;
}

.step-item > span {
  color: #999999;
  font-size: 16px;
}

.step-item > span:first-child {
  display: inline-block;
  width: 35px;
  height: 35px;
  background-color: #c9c9c9;
  border-radius: 50%;
  text-align: center;
  line-height: 35px;
  color: #ffffff;
}

.step-item > span:nth-child(3) {
  margin-left: 20px;
}

.steps > .active > span:nth-child(1) {
  background-color: $--color-primary;
}

.steps > .active > span:nth-child(2) {
  color: $--color-primary;
}

</style>



// WEBPACK FOOTER //
// src/components/global/Header.vue